import script from "./divider.vue?vue&type=script&setup=true&lang=js"
export * from "./divider.vue?vue&type=script&setup=true&lang=js"

import "./divider.vue?vue&type=style&index=0&id=97818c42&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97818c42"]])

export default __exports__